import React from "react"
import { Typography, useTheme } from "@material-ui/core"
import AvatarComBadge from "../../AvatarComBadge"
import telefoneFormatar from "../../../utils/telefoneFormatar"
import { canais } from "../../../utils/canais"
import { LockKeyhole } from "lucide-react"

export const InfoContato = ({ initialContact }) => {
  const theme = useTheme()

  const cTipoCanal = Object.keys(canais).find((key) => canais[key] === initialContact?.canalId)

  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <AvatarComBadge
        cSrcPrincipal={initialContact?.imagemPerfil}
        cNomePrincipal={initialContact?.nome}
        cNomeAbreviacao={cTipoCanal === "interno" ? initialContact?.nomeAbreviacao : undefined}
        cTipoCanal={cTipoCanal}
        nTamanho={48}
      />

      <div style={{ display: "flex", flexDirection: "column", marginLeft: 8 }}>
        <Typography
          style={{
            fontFamily: "font/family/title",
            fontWeight: 500,
            fontSize: 16,
            lineHeight: "125%",
            letterSpacing: "-0.25%",
            color: theme.palette.neutral400,
          }}
        >
          {initialContact?.nome}
        </Typography>

        <Typography
          component="div"
          style={{
            marginTop: 2,
            fontFamily: "font/family/body",
            fontWeight: 400,
            fontSize: 14,
            lineHeight: "125%",
            letterSpacing: "-0.25%",
            color: theme.palette.neutral300,
          }}
        >
          {initialContact?.numero ? (
            telefoneFormatar(initialContact)
          ) : (
            <div style={{ display: "flex", textAlign: "center", gap: 2 }}>
              <LockKeyhole size={16} />
              Chat interno
            </div>
          )}
        </Typography>
      </div>
    </div>
  )
}
